/**
 * Kaynak sahnelerin anlatımlarını modele gidecek tek metne çevirir.
 *
 * Kendi dosyasında ve SAF: davranışı sessizce yanlış olabilecek üç kurala
 * dayanıyor, yani test edilebilir olmaları gerekiyor. Bileşenin içinde
 * kalsalardı ancak redux store'u ve servisleri ayağa kaldırarak denenebilirdi.
 */

/**
 * Bir sahnenin EKRANDAKİ metni.
 *
 * Taslak (yazarın kutuda düzenlediği hâli) varsa o, yoksa sahnenin kendi
 * anlatımı. Taslak BOŞ DİZE olabilir — yazar metni tamamen silmiş demektir ve
 * bu geçerli bir karar; `|| scene.narration` yazılsaydı silinen metin
 * kendiliğinden geri gelirdi.
 */
export function draftTextOf(scene, draftsById) {
  if (!scene) return "";
  const draft = draftsById && draftsById[scene.id];
  return draft !== undefined ? draft : scene.narration || "";
}

/**
 * Seçili sahnelerin metinlerini birleştirir.
 *
 * `scenes` zaten SEÇİLİ sahnelerin kurs sırasındaki listesi — sıralama
 * çağıranın işi, burada yeniden sıralanmaz.
 *
 * TEK sahnede başlık YOK: metnin başına yazarın yazmadığı bir satır
 * eklenmemeli.
 *
 * BİRDEN FAZLA sahnede başlık VAR. Ekranda her sahne kendi kutusunda duruyor
 * ama modele giden tek bir metin: sınırsız yapıştırılan iki anlatım onun
 * gözünde tek bir metindir ve ikinci sahnenin konusu birincinin devamı
 * sanılır. Başlık o sınırı taşıyan tek şey.
 */
export function composeNarration(scenes, draftsById) {
  const parts = (scenes || [])
    .map((scene) => ({ scene, text: draftTextOf(scene, draftsById).trim() }))
    .filter((part) => part.scene && part.text);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].text;
  return parts
    .map((part) => `[${part.scene.index}. ${part.scene.name}]\n${part.text}`)
    .join("\n\n");
}
